"use strict";

exports.__esModule = true;
exports.resolveValue = exports.resolvePulseAnimation = exports.resolveHeight = void 0;
var _styledComponents = require("styled-components");
const resolveValue = value => {
  if (typeof value === "string") return value;
  if (typeof value === "number") return `${value}px`;
  return "100%";
};
exports.resolveValue = resolveValue;
const resolveHeight = ({
  calculatedHeight,
  height
}) => {
  if (calculatedHeight) return `${calculatedHeight}px`;
  if (height) return resolveValue(height);
  return "100%";
};
exports.resolveHeight = resolveHeight;
const pulseAnimation = (0, _styledComponents.keyframes)(["0%{opacity:1;}50%{opacity:0.3;}100%{opacity:1;}"]);
const resolvePulseAnimation = ({
  animate,
  duration,
  interval
}) => {
  if (animate) {
    return (0, _styledComponents.css)(["animation:", " ", " ease-in-out ", " infinite;"], pulseAnimation, duration, interval);
  }
  return null;
};
exports.resolvePulseAnimation = resolvePulseAnimation;